import {
  cornerPin2
} from "./index-r0v18b2n.mjs";
export {
  cornerPin2 as cornerPin
};
